module.exports = "https://static.energy5.com/_next/static/images/rebates-d3dc299e7a2a6f61b142cb6b299deee3.webp";